<template>
  <app-admin>
    <div class="container content">
      <loader ref="mainLoader"/>
      <div class="flex-between">
        <h1>Группы</h1>
        <router-link :to="{name: 'NewGroup'}" v-if="groups.length != 0">
          <div class="btn">
            <font-awesome-icon icon="plus"/>
            Добавить новую группу
          </div>
        </router-link>
      </div>
      <div class="no-players" v-show="groups.length == 0 && filter.length == 0 && resultCount==0">
        <div class="text">
          У Вас пока нет ни одной созданной группы.
          <br>
          Добавьте новую группу
        </div>
        <router-link :to="{name: 'NewGroup'}">
          <div class="btn btn-lg">
            Добавить новую группу
          </div>
        </router-link>
      </div>

      <div class="players" v-show="!(groups.length == 0 && filter.length == 0 && resultCount==0)">
        <app-search @change="handleFilter" debounce="500"/>
        <div class="relative">
          <loader ref="loader"/>
          <table cellspacing="0" cellpadding="0" class="main-table">
            <thead>
            <tr>
              <th class="index">№</th>
              <th>Название группы</th>
              <th>Отчет</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="groups.length == 0">
              <td colspan="5" class="text-center">
                <em>Групп не найдено.</em>
              </td>
            </tr>
            <tr v-for="(group, index) in groups" :key="group.id">
              <td>{{(itemsPerPage*(currentPage-1)) + index+1}}</td>

              <router-link :to="{ name: 'Group', params: { id: group.id }}" tag="td" class="hover">{{group.name}}
              </router-link>
              <td>
                <!--<router-link class="btn" :to="{ name: 'EditGroup', params: { id: group.id }}">-->
                  <!--Получить отчет-->
                <!--</router-link>-->
                <span class="btn" @click="showedModalId = group.id">
                  Получить отчет
                </span>
              </td>
              <td>
                {{group.created}}
              </td>
              <td>
                <router-link :to="{ name: 'EditGroup', params: { id: group.id }}">
                  <font-awesome-icon icon="edit"
                                     v-tooltip="{content: 'Редактировать данные группы', class: 'tooltip-custom'}"/>
                </router-link>
                <font-awesome-icon icon="trash-alt" v-tooltip="{content: 'Удалить группу', class: 'tooltip-custom'}"
                                   @click="removeGroup(group)"/>
              </td>
              <csv-modal :groupId="group.id" v-if="showedModalId === group.id" @close="showedModalId = -1"></csv-modal>
            </tr>

            </tbody>
          </table>
        </div>

        <pagination @change="setPage" :itemsPerPage="itemsPerPage" :resultCount="resultCount"/>

      </div>
      <transition name="fade">
        <confirm-modal v-if='confirmModal' @confirm='deleteGroup' @cancel="cancelDeleteGroup">
          Вы действительно хотите удалить группу <br>
          {{groupToRemove.name}}?
        </confirm-modal>
      </transition>
    </div>
  </app-admin>
</template>

<script>
  import ConfirmModal from '@/components/modal/ConfirmModal'
  import CSVModal from '@/components/modal/CSVModal'

  import GroupsService from '@/services/GroupsService'

  export default {
    name: 'Groups',
    components: {
      'confirm-modal': ConfirmModal,
      'csv-modal': CSVModal
    },
    data () {
      return {
        groups: [],
        filter: '',
        currentPage: 1,
        itemsPerPage: 10,
        resultCount: 0,
        groupToRemove: {},
        confirmModal: false,
        showedModalId: -1
      }
    },
    computed: {},
    methods: {
      removeGroup (group) {
        this.groupToRemove = group
        this.confirmModal = true
      },
      deleteGroup () {
        GroupsService.deleteGroup(this.groupToRemove.id).then(
          (response) => {
            this.groups.splice(this.groups.indexOf(this.groupToRemove), 1)
            this.confirmModal = false
          },
          (error) => {
            console.log(error)
          }
        )
      },
      cancelDeleteGroup () {
        this.confirmModal = false
      },
      handleFilter: function (filter) {
        this.filter = filter
        this.getGroups()
      },
      setPage (pageNumber) {
        this.currentPage = pageNumber
        this.getGroups()
      },
      getGroups () {
        this.$refs.loader.show()
        const slug = this.$store.getters.slug
        GroupsService.getGroups(slug, this.currentPage, this.itemsPerPage, this.filter).then(
          (response) => {
            this.groups = response.results
            this.resultCount = response.count
            this.$refs.loader.hide()
            this.$refs.mainLoader.hide()
          }
        )
      }
    },
    mounted () {
      this.$refs.mainLoader.show()
      this.getGroups()
    }
  }
</script>

<style scoped lang="scss">
  .no-players {
    margin-top: 150px;
    text-align: center;
    .text {
      color: #666666;
      font-weight: 300;
      font-size: 1.5em;
      line-height: 2em;
      margin-bottom: 20px;
    }
  }

  table {
    td, th {
      &:nth-child(3) {
        text-align: left !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/admin/groups/Groups.vue